import { render, staticRenderFns } from "./OpenField.vue?vue&type=template&id=813b3e72&scoped=true"
import script from "./OpenField.vue?vue&type=script&lang=js"
export * from "./OpenField.vue?vue&type=script&lang=js"
import style0 from "./OpenField.vue?vue&type=style&index=0&id=813b3e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813b3e72",
  null
  
)

export default component.exports